<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <!-- Botón de regreso -->
        <v-row dense class="align-center justify-space-between">
          <v-col cols="auto">
            <v-btn icon @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <!-- <v-btn class="cancel" @click="Cancelar"> Cancelar </v-btn> -->
            <save-btn
              class="btn-oval"
              :record-status="agroturismo.estatus"
              :loading="loading"
              @click="guardarYContinuar"
            />
          </v-col>
        </v-row>

        <v-col cols="12">
          <div class="text-h5 font-weight-bold">
            <span style="font-size: 30px">🏕️</span> Agroturísmo
          </div>
        </v-col>
        <!--         
        </v-col> -->
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Los campos con * son requeridos
          </div>
        </v-col>
        <!--
        <v-col cols="12">
          <v-select
            v-model="agroturismo.estatus"
            :items="estatus"
            label="Estatus"
            outlined
          />
        </v-col> -->

        <v-col cols="12">
          <v-select
            v-model="agroturismo.id_finca"
            :no-data-text="$vuetify.noDataText"
            :rules="[r.required]"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Finca*"
            outlined
            @input="debounceBuscarRegistroExistente"
          >
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="12">
          <div class="d-flex justify-end">
            <modal-parcela />
          </div>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="agroturismo.id_parcela"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :items="parcelasPorId(agroturismo.id_finca)"
            item-value="id"
            item-text="nombre"
            label="Actividad"
          ></v-select>
        </v-col>
        <v-col cols="12">
          <div class="d-flex justify-end">
            <modal-establecimiento />
          </div>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="agroturismo.id_establecimiento"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            :items="establecimientosPorId(agroturismo.id_finca)"
            item-value="id"
            item-text="rua"
            label="Área"
          ></v-select>
        </v-col>

        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            Fecha y Hora del evento/ actividad/ experiencia
          </div>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="agroturismo.fecha"
            label="Fecha inicio*"
            :rules="[r.required]"
            outlined
            name="fecha"
            placeholder="aaaa-mm-dd"
            @input="validarFecha(agroturismo.fecha)"
           
          ></v-text-field>
          <p v-if="error" style="color: red">{{ error }}</p>
        </v-col>
         <!-- @change="debounceBuscarRegistroExistente" -->
        <!--   <v-col cols="6">
          <v-text-field
            v-model.number="agroturismo.ciclo"
            :rules="[r.required, r.int, r.min_num(1), r.max_num(9)]"
            label="Ciclo*"
            outlined
            @input="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <v-col cols="6">
          <v-text-field
            v-model="agroturismo.hora_inicio"
            label="Hora Inicio"
            placeholder="hh:mm AM/PM"
            auto-grow
            outlined
            rows="1"
            @input="validarHora(agroturismo.hora_inicio)"
          ></v-text-field>
          <p v-if="errorHoraInicio" style="color: red">{{ errorHoraInicio }}</p>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="agroturismo.fecha_fin"
            label="Fecha finalización*"
            :rules="[r.required]"
            outlined
            name="fecha"
            placeholder="aaaa-mm-dd"
            @input="validarFechaf(agroturismo.fecha_fin)"
            @change="debounceBuscarRegistroExistente"
          ></v-text-field>
          <p v-if="errorFechaFin" style="color: red">{{ errorFechaFin }}</p>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="agroturismo.hora_fin"
            label="Hora Finalización"
            placeholder="hh:mm AM/PM"
            auto-grow
            outlined
            rows="1"
            @input="validarHoraFin(agroturismo.hora_fin)"
          ></v-text-field>
          <p v-if="errorHoraFin" style="color: red">{{ errorHoraFin }}</p>
        </v-col>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            Datos del evento/ actividad/ experiencia
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="agroturismo.produccion"
            :rules="[r.required, r.float]"
            label="Cantidad de personas*"
            auto-grow
            outlined
            rows="1"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model.number="agroturismo.ingreso_anual"
            :rules="[r.required, r.float]"
            label="Precio Total*"
            suffix="$"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="agroturismo.descripcion"
            counter="1000"
            :rules="[r.required, r.max(1000)]"
            label="Descripción de la actividad o servicio *"
            outlined
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="agroturismo.observacion"
            label="Tarea_Pendiente, Fecha, Observación"
            auto-grow
            outlined
            rows="1"
          ></v-textarea>
        </v-col>
        <!--  <v-col cols="12">
          <div class="text-h6">Datos del evento/actividad/experiencia</div>
        </v-col> -->

        <!-- Situación de desastre -->
        <!--         <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarDesastre">
            <v-icon left>mdi-plus</v-icon>
            Agregar situación de desastre
          </v-btn>
        </v-col>
        <situacion-de-desastre
          v-for="(desastre, index) in agroturismo.desastres"
          :key="desastre.id_trxdano"
          :form="agroturismo.desastres[index]"
          :modulo="'AGROTURISMO'"
          @eliminar="eliminarDesastre(index)"
        /> -->
        <!--   <v-col cols="12">
          <div class="text-6">Mis Tareas Pendientes o Anotaciones</div>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="agroturismo.observacion"
            :rules="[r.max(1000)]"
            label="Mis Tareas Pendientes o Anotaciones"
            auto-grow
            outlined
            rows="1"
          ></v-textarea>
        </v-col> -->
      </v-row>
    </v-form>
    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import uuid from 'uuid/v4'
import { mapState, mapGetters } from 'vuex'
import debounce from 'lodash.debounce'
import * as rules from '@/utils/validations'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import { toArray, clona, elObjetoTienePropiedades } from '../../utilidades'
import { danotrx } from '../../modelos'
import { formulario_de_agroturismo } from '../../modelos'
import ModalParcela from '../../components/ModalParcela.vue'
import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'

export default {
  name: 'Agroturismo',
  components: {
    FincaSelectItem,
    ModalParcela,
    ModalEstablecimiento,
    SituacionDeDesastre,
  },
  data: () => {
    return {
      error: '',
      errorFecha: '',
      errorHoraInicio: '',
      errorFechaFin: '',
      errorHoraFin: '',
      r: rules,
      validado: false,
      modal_registro_existe: false,
      modal_registro_existe_loading: false,
      registro_existente: {},
      agroturismo: clona(formulario_de_agroturismo),
      loading: false,
    }
  },
  computed: {
    fincas() {
      return toArray(this.$store.state.registros.fincas)
    },
    ...mapState('listados', ['destino', 'estatus']),
    ...mapState('registros', ['productor']),
    ...mapGetters('registros', [
      'existeRegistroEnState',
      'establecimientosPorId',
      'parcelasPorId',
      'productor_actual',
    ]),
    ...mapGetters('auth', ['user']),
  },
  watch: {
    '$route.params.id'() {
      this.cargarRegistro(this.obtenerIdDeRuta())
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Agroturismo')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
      this.agroturismo.fecha
      this.agroturismo.fecha_fin
      this.agroturismo.hora_inicio
      this.agroturismo.hora_fin
    } else {
      this.agroturismo = clona(formulario_de_agroturismo)
      //Establece la fecha de inicio al cargar la página en fecha hoy
      /*  this.agroturismo.fecha = this.fechaHoyYYYYMMDD()
       this.agroturismo.fecha_fin = this.fechaHoyYYYYMMDD()
       this.agroturismo.hora_inicio = this.HoraActualAMPM()
       this.agroturismo.hora_fin = this.HoraActualAMPM() */
    }

    this.agroturismo.id_productor = this.productor_actual

    if (!this.agroturismo.ciclo) {
      this.agroturismo.ciclo = 1
    }
  },
  methods: {
    // registra los datos agroturísticos en el almacenamiento local
    async guardarYContinuar() {
      try {
        this.loading = true
        if (!this.$refs.form.validate()) {
          this.$store.commit('ui/setSnack', {
            text: 'Verifique los elementos en rojo',
            color: 'error',
          })
          return ''
        }
        if (await this.buscarRegistroExistente()) return
        // Antes de guardar en DB, convertir:
        let horaInicioDB = this.convertirHoraAMPMa24(
          this.agroturismo.hora_inicio
        )
        let horaFinDB = this.convertirHoraAMPMa24(this.agroturismo.hora_fin)
        // Enviar a la base de datos:
        this.agroturismo.hora_inicio = horaInicioDB
        this.agroturismo.hora_fin = horaFinDB

        if (!this.obtenerIdDeRuta()) {
          this.agroturismo.id = uuid()
          this.agroturismo.created_at = new Date().getTime() / 1000
        } else this.agroturismo.updated_at = new Date().getTime() / 1000
        this.$router.push('/ru/agroturismos')
        await this.$store.dispatch(
          'registros/guardarAgroturismo',
          clona(this.agroturismo)
        )
      } catch (error) {
        this.$sentry.captureException(error)
      } finally {
        this.loading = false
      }
    },
    async cargarRegistroExistente() {
      const id = this.registro_existente.id
      this.modal_registro_existe_loading = true
      if (!this.existeRegistroEnState('agroturismos', id)) {
        await this.cargarRegistroDelServer(this.registro_existente)
      }
      this.$router.push(`/ru/agroturismo/${id}`)
      this.cerrarModalRegistroExistente()
      this.modal_registro_existe_loading = false
    },
    formatearFechaParaFormulario(fechaYYYYMMDD) {
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regex.test(fechaYYYYMMDD)) return fechaYYYYMMDD
      const [, anio, mes, dia] = fechaYYYYMMDD.match(regex)
      return `${dia}-${mes}-${anio}`
    },
    formatearFechaParaBD(fechaDDMMYYYY) {
      const regex = /^(\d{2})-(\d{2})-(\d{4})$/
      if (!regex.test(fechaDDMMYYYY)) return fechaDDMMYYYY
      const [, dia, mes, anio] = fechaDDMMYYYY.match(regex)
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    fechaHoyYYYYMMDD() {
      const hoy = new Date()
      const dia = String(hoy.getDate()).padStart(2, '0')
      const mes = String(hoy.getMonth() + 1).padStart(2, '0')
      const anio = hoy.getFullYear()
      return `${anio}-${mes}-${dia}`
    },
    HoraActualAMPM() {
      const ahora = new Date()
      let horas = ahora.getHours()
      const minutos = ahora.getMinutes().toString().padStart(2, '0')
      const ampm = horas >= 12 ? 'PM' : 'AM'
      horas = horas % 12
      horas = horas ? horas : 12
      return `${horas}:${minutos} ${ampm}`
    },
    cargarRegistro(id) {
      if (this.existeRegistroEnState('agroturismos', id)) {
        this.agroturismo = this.obtenerRegistroDelState(id)
        this.$refs.form.resetValidation()
        return true
      } else return false
    },
    async buscarRegistroExistente() {
      const registro = await this.obtenerUnRegistroONada()
      if (elObjetoTienePropiedades(registro)) {
        const id = registro.id ? registro.id.toString() : ''
        if (id === this.obtenerIdDeRuta()) return false
        this.almacenarRegistroEncontradoTemporalmente(registro)
        this.mostrarModalDeRegistroExistente()
        return true
      }
      return false
    },
    debounceBuscarRegistroExistente: debounce(async function () {
      await this.buscarRegistroExistente()
    }, 1500),
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.agroturismo.id_productor
        const ciclo = this.agroturismo.ciclo
        const fecha = this.agroturismo.fecha
        const id_finca = this.agroturismo.id_finca
        const id_parcela = this.agroturismo.id_parcela

        // required fields to be fulfilled
        if (fecha && id_finca) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarAgroturismosx',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    async cargarRegistroDelServer(registro) {
      try {
        await this.$store.dispatch('registros/getAgroturismo', registro)
        return true
      } catch (e) {
        return false
      }
    },
    Cancelar() {
      this.$router.push('/ru/agroturismos')
    },
    agregarDesastre() {
      this.agroturismo.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.agroturismo.desastres?.splice(index, 1)
    },
    mostrarModalDeRegistroExistente() {
      this.modal_registro_existe = true
    },
    cerrarModalRegistroExistente() {
      this.modal_registro_existe = false
    },
    almacenarRegistroEncontradoTemporalmente(registro) {
      this.registro_existente = registro
    },
    obtenerRegistroDelState(id) {
      return {
        ...formulario_de_agroturismo,
        ...this.$store.state.registros.agroturismos[id],
      }
    },
    obtenerIdDeRuta() {
      return this.$route.params.id || ''
    },
    validarFecha(fecha) {
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // formato aaaa-mm-dd
      if (!regexFecha.test(fecha)) {
        this.error = 'Favor colocar la fecha en el formato correcto: aaaa-mm-dd'
        return
      }

      const [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.error = 'El mes debe estar en el rango de 1 a 12.'
        return
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.error = 'El día no es válido para el mes especificado.'
        return
      }

      this.error = '' // todo bien
    },
    validarFechaf(fecha) {
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // aaaa-mm-dd
      if (!regexFecha.test(fecha)) {
        this.errorFechaFin =
          'Favor colocar la fecha en el formato correcto: aaaa-mm-dd'
        return
      }

      let [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.errorFechaFin = 'El mes debe estar en el rango de 1 a 12.'
        return
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.errorFechaFin = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
        return
      }

      this.errorFechaFin = ''
    },
    validarHora(hora) {
      let regexHora = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i
      if (!regexHora.test(hora.trim())) {
        this.errorHoraInicio =
          'Favor colocar la hora en formato hh:mm AM/PM, por ejemplo: 2:30 PM'
        return
      }
      this.errorHoraInicio = ''
    },
    validarHoraFin(hora) {
      let regexHora = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i
      if (!regexHora.test(hora.trim())) {
        this.errorHoraFin =
          'Favor colocar la hora en formato hh:mm AM/PM, por ejemplo: 2:30 PM'
        return
      }
      this.errorHoraFin = ''
    },
    convertirHora24aAMPM(hora24h) {
      if (!hora24h) return ''
      const regex = /^(\d{2}):(\d{2})(?::\d{2})?$/
      const match = hora24h.match(regex)
      if (!match) return ''
      let [_, hh, mm] = match
      let hora = parseInt(hh, 10)
      const minutos = mm
      let ampm = 'AM'
      if (hora >= 12) {
        ampm = 'PM'
        if (hora > 12) hora -= 12
      }
      if (hora === 0) {
        hora = 12
      }
      return `${hora}:${minutos} ${ampm}`
    },
    convertirHoraAMPMa24(hora12h) {
      if (!hora12h) return ''
      hora12h = hora12h.trim().toUpperCase()
      // Extraer partes con regex
      const regex = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/
      const match = hora12h.match(regex)
      if (!match) return '' // formato inválido
      let [_, hora, minutos, ampm] = match
      hora = parseInt(hora, 10)
      minutos = minutos.padStart(2, '0')
      if (ampm === 'PM' && hora !== 12) {
        hora += 12
      }
      if (ampm === 'AM' && hora === 12) {
        hora = 0
      }
      // Formatear hora con dos dígitos
      const hora24 = hora.toString().padStart(2, '0')
      return `${hora24}:${minutos}:00` // segundos fijos 00
    },
    convertirHora24aAMPM(hora24h) {
      if (!hora24h) return ''
      // Extraer hh:mm (puede venir con o sin segundos)
      const regex = /^(\d{2}):(\d{2})(?::\d{2})?$/
      const match = hora24h.match(regex)
      if (!match) return ''

      let [_, hh, mm] = match
      let hora = parseInt(hh, 10)
      const minutos = mm
      let ampm = 'AM'

      if (hora >= 12) {
        ampm = 'PM'
        if (hora > 12) hora -= 12
      }
      if (hora === 0) {
        hora = 12
      }
      return `${hora}:${minutos} ${ampm}`
    },
  },
}
</script>

<style>
.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}
</style>
